export const REVIEW_KIND = 1985;
export const RELAY_REVIEW_LABEL = "review/relay";
export const RELAY_REVIEW_LABEL_NAMESPACE = "social.coracle.ontology";
